import goalSettingsStepsSchema from './GoalSettings/stepsSchema';
import dietSettingsStepsSchema from './DietSettings/stepsSchema';
import biometricSettingsStepsSchema from './BiometricSettings/stepsSchema';

import packageJson from '../package.json';
export const ALLOWED_LANGUAGES = ['en-US'];

export const SENTRY_DSN =
  'https://a9aaed2a0229e886061bccd300dbbbd0@o251048.ingest.us.sentry.io/4509389055459328';

export const APP_STORE_URL = 'https://raize.onelink.me/FwjF/9mg94lyi';
export const GOOGLE_PLAY_URL = 'https://raize.onelink.me/FwjF/9mg94lyi';

export const APP_VERSION = packageJson.version;
export const APP_BRAND = 'raize';

export const GTM_ID = 'GTM-NBCW64K8';

export const SLIDE_ROUTES_DURATION = 350;

export const LANDING_URL = 'https://raize.fit/';

export const siteMetadata = {
  lang: 'en',
  shortName: 'raize',
  name: 'Raize',
  themeColor: '#ffffff',
  title: 'Raize',
  description: '',
  keywords: ['raize'],
  author: 'activerse.app',
};

export const INSTACART_FIREBASE_FUNCTION = 'https://instacartgenerator-tzlx7uko5q-uc.a.run.app';
export const INSTACART_URL = 'https://www.instacart.com/store/partner_recipes';

export const FRISCO = false;

export const FIRST_DIET_SETTINGS_STEP_SLUG = dietSettingsStepsSchema[0].slug;
export const FIRST_GOAL_SETTINGS_STEP_SLUG = goalSettingsStepsSchema[0].slug;
export const FIRST_BIOMETRIC_SETTINGS_STEP_SLUG = biometricSettingsStepsSchema[0].slug;

export const FORCE_BUILD = false;
